// extracted by mini-css-extract-plugin
export default {"modal":"dialog_modal__kuhkQ","title":"dialog_title__IQcyw","content":"dialog_content__M2GtH"};